import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MFunctionalCardIconComponent } from './functional-card-icon.component';
import { MFunctionalCardComponent } from './functional-card.component';

@NgModule({
  imports: [CommonModule, FormsModule, NzIconModule, NzOutletModule],
  exports: [MFunctionalCardComponent, MFunctionalCardIconComponent],
  declarations: [MFunctionalCardComponent, MFunctionalCardIconComponent]
})
export class MFunctionalCardModule {}
